import * as React from 'react'

const SvgUploadFile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={163} height={165} viewBox="0 0 163 165" fill="none" {...props}>
    <path
      d="M73.603 155.705l8.897 4.412 30.5-13.724c.032-.371 28-22.547 28-22.547l-2.5-9.313c0-10.783-14.5-12.253-14.5-12.253l-14.404-3.645-33.304-9.59c0 3.708-2.69 9.59 0 9.59l-2.69 53.639c.287-6.316 0-3.843 0 3.431z"
      fill="url(#upload-file_svg__paint0_radial_2897_1046)"
      fillOpacity={0.6}
    />
    <path
      d="M135.141 43.793c0-24.006-21.779-43.463-48.65-43.463-23.385 0-42.894 14.744-47.57 34.384a36.67 36.67 0 00-6.487-.58C14.52 34.135 0 47.107 0 63.11c0 16.005 14.52 28.976 32.434 28.976h25.72l11.465-10.243c3.06-2.738 7.13-4.245 11.466-4.245 4.335 0 8.406 1.507 11.465 4.245l11.466 10.243h31.125c14.925 0 27.029-10.813 27.029-24.146 0-13.334-12.104-24.147-27.029-24.147z"
      fill="#A2ADB9"
    />
    <path
      d="M122.902 52.288c0-20.404-16.848-36.941-37.636-36.941-18.09 0-33.182 12.53-36.799 29.224-1.622-.32-3.3-.493-5.018-.493-13.858 0-25.09 11.025-25.09 24.628 0 13.602 11.232 24.627 25.09 24.627h19.897l8.87-8.706c2.366-2.327 5.515-3.608 8.869-3.608s6.502 1.281 8.87 3.608l8.869 8.706h24.078c11.546 0 20.909-9.19 20.909-20.523 0-11.332-9.363-20.523-20.909-20.523z"
      fill="#D9D9D9"
    />
    <path
      d="M117.066 119.545a10.972 10.972 0 010 15.661c-4.375 4.325-11.489 4.325-15.864 0l-8.897-8.783v23.103c0 6.114-5.027 11.075-11.22 11.075-6.193 0-11.22-4.961-11.22-11.075v-23.103l-8.897 8.783c-4.376 4.325-11.489 4.325-15.865 0a10.973 10.973 0 010-15.661l28.05-27.688c4.375-4.325 11.488-4.325 15.864 0l28.049 27.688z"
      fill="#F79D61"
    />
    <defs>
      <radialGradient
        id="upload-file_svg__paint0_radial_2897_1046"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(43.9149 8.73036 -37.58236 189.04448 75.313 105.006)"
      >
        <stop stopColor="#163250" stopOpacity={0.23} />
        <stop offset={1} stopColor="#163250" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)

export default SvgUploadFile
